module.exports = __webpack_public_path__ + "img/i03.46e398a6.svg";